import React, { useState } from 'react';
import { NoPackageAvailable, select_arrow } from '../../../assets/images';
import EmptyListCard from './EmptyListCard';

const PreEmpPackageSelector = ({options=[], handleSelect, availablity_check = false}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedName, setSelectedName] = useState('')

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const getName = (id) => {
    let item = options.find(item => item.id === id)
    return item.name
  }

  const handleOptionSelect = (option) => {
    handleSelect(option)
    setSelectedName(getName(option))
    setSelectedOption(option);
    setIsOpen(false);
  };

  const getList = () => {
    return options.map((option, i) => {
      const disabled = availablity_check && (!(option?.prev_split_availed ?? true) || (option?.current_package_availed ?? false));
      return (
        <div key={option.id} onClick={() => (!disabled) ? handleOptionSelect(option.id) : null} className={`px-3 py-1 hover:bg-gray-100 w-full my-1 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
          { option.name }
        </div>
      )}
    )
  }

  const getEmptyList = () => {
    return (
          <EmptyListCard
            svgsrc={NoPackageAvailable}
            svgClasses='h-16'
            classes='my-4'
            title='No packages found'
            subTitleClasses='w-72'
            subTitle='Currently there are no packages available for this person in this category.'
            />
            )
  }

  return (
    <div className=''>
      <div className={`border border-gray-200 bg-white flex rounded-md py-2 px-3 cursor-pointer`}>
        <input
          className={`select w-full placeholder-gray-300 cursor-pointer ${selectedName.length > 0 ? 'text-gray-700 font-semibold': 'font-semibold'} cursor-pointer`}
          style={{ borderColor: 'transparent'}}
          type="text"
          value={selectedName ? selectedName : ''}
          placeholder="Select a package"
          readOnly
          onClick={toggleDropdown}
        />
        <img src={select_arrow} alt='arrow-icon' className={`inline-block mr-1 cursor-pointer transform transition-colors ease-in-out duration-500 ${ isOpen ? 'rotate-180' : ''} cursor-pointer`} onClick={toggleDropdown}/>
      </div>
      {isOpen && (
        <div className={`border border-gray-200 bg-white shadow-md rounded-md w-full text-gray-600 text-base overflow-auto scroll-smooth my-1 w-full ${options.length > 4 ? 'h-44' : 'h-auto'}`} style={{color: '#4D6189'}}>
          {options.length > 0 ? getList() : getEmptyList()}
        </div>
      )}
    </div>
  );
};

export default PreEmpPackageSelector;
